export default {

    async exportCsv(dados) {
        let dadosFinal = []

        for (const dado of dados) {
            if (dado.tipoConvenio) {
                delete dado.convenioId
                dado.tipoConvenio = dado.tipoConvenio.descricao
            }

            if(dado.tipoDocumento) {
                delete dado.documentoId
                delete dado.contemHtml
                delete dado.status
                delete dado.destino
                dado.tipoDocumento = dado.tipoDocumento.nome
            }

            dadosFinal.push(dado)
        }

        const csv = this.objectToCsv(dadosFinal);
        // O BOM (U+FEFF) faz o Excel reconhecer o arquivo como UTF-8 e exibir os acentos
        const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'dados.csv');
        document.body.appendChild(link);
        link.click();

    },

    objectToCsv(data) {
        const csvRows = [];
        const headers = Object.keys(data[0]);
        csvRows.push(headers.map(this.escapeCsv).join(';'));

        for (const row of data) {
            const values = headers.map(header => this.escapeCsv(row[header]));
            csvRows.push(values.join(';'));
        }
        return csvRows.join('\r\n');
    },

    escapeCsv(val) {
        if (val === null || val === undefined) {
            return '';
        }
        // duplica as aspas internas e envolve o campo em aspas (RFC 4180),
        // assim aspas, ; e quebras de linha no texto nao quebram as colunas
        const str = String(val).replace(/"/g, '""');
        return `"${str}"`;
    },

}